import styled from "styled-components";

/**
 * Button Component
 *
 * A reusable button component that supports dynamic disabling, tooltips,
 * and custom styles. Useful for consistent button rendering across modals,
 * tables, and forms.
 *
 * @component
 *
 * @param {string} btnName - Text displayed inside the button.
 * @param {Function} handler - Callback function called when the button is clicked.
 * @param {string} classOfBtn - Additional CSS class names for styling (e.g., "createReportBtn").
 * @param {boolean} [isDisabledButton=false] - If true, disables the button.
 * @param {string} titleForDisabledBtn - Tooltip text shown when the button is disabled.
 * @param {string} titleForActive - Tooltip text shown when the button is active (enabled).
 *
 */

export const Button = ({
  btnName,
  handler,
  classOfBtn,
  isDisabledButton = false,
  titleForDisabledBtn,
  titleForActive,
}) => {
  return (
    <ButtonElement
      className={classOfBtn}
      onClick={handler}
      title={isDisabledButton ? titleForDisabledBtn : titleForActive}
      disabled={isDisabledButton ? true : false}
    >
      {btnName}
    </ButtonElement>
  );
};

const ButtonElement = styled.button`
  height: 32px;
  line-height: 16px;
  padding: 4px 15px;
  border-radius: 4px;
  color: var(--White, #fff);
  background-color: var(--BLUE, #2060ea);
  border: 1px solid transparent;
  &:disabled {
    background-color: var(--MIST, #f7f8f9) !important;
    color: var(--character-disabled-placeholder-25, rgba(0, 0, 0, 0.25)) !important;
  }
`;
